import React, { useState } from "react";
import "../styles/Register.css";
import registerImg from "../assets/img/bg_1.jpg";
import { FaPaperPlane } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { sendOTP } from "../api/authApi";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  // Email validation
  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email.trim()) {
      toast.error("Email is required.");
      return;
    }
    if (!validateEmail(email)) {
      toast.error("Please enter a valid email address.");
      return;
    }

    setLoading(true);
    try {
      const res = await sendOTP({ email });
      if (res.data?.status || res.status === 200) {
        toast.success("OTP sent to your email.");
        // Pass email in query params
        navigate(`/reset-password?email=${encodeURIComponent(email)}`);
      } else {
        toast.error(res.data?.message || "Failed to send OTP.");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to send OTP.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="register-wrapper">
      <div className="register-bg">
        <img src={registerImg} alt="Forgot Password" />
      </div>

      <div className="register-form-container flip-in-left">
        <h3 className="form-title">Forgot Password</h3>
        <form className="register-form" onSubmit={handleSubmit}>
          <div className="floating-input">
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <label htmlFor="email">Enter your Email</label>
          </div>

          <div className="d-flex justify-content-between align-items-center mt-3">
            <p className="mb-0">
              Remember your password? <a href="/login">Login</a>
            </p>
            <button type="submit" className="submit-btn" disabled={loading}>
              {loading ? "..." : <FaPaperPlane />}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
